import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  Badge,
  Textarea,
  Icon,
  VStack,
  HStack,
  Divider,
} from "@chakra-ui/react";
import { ArrowBackIcon, AttachmentIcon } from "@chakra-ui/icons";
import { FiTrash2, FiCornerDownLeft } from "react-icons/fi";

const ReplyTicket = () => {
  return (
    <Box p={{ base: 4, md: 6 }}>
      {/* Header */}
      <Flex
        justify="space-between"
        align="center"
        mb={6}
        flexWrap="wrap"
        gap={4}
      >
        <Heading size="md">Reply Ticket</Heading>

        <Button
          leftIcon={<ArrowBackIcon />}
          variant="outline"
          colorScheme="purple"
          size="sm"
        >
          Back
        </Button>
      </Flex>

      {/* Ticket Card */}
      <Box bg="white" p={{ base: 4, md: 6 }} borderRadius="lg">
        {/* Ticket Title */}
        <Flex
          justify="space-between"
          align="center"
          flexWrap="wrap"
          gap={4}
          mb={4}
        >
          <HStack>
            <Badge
              colorScheme="green"
              variant="outline"
              px={3}
              borderRadius="full"
            >
              Open
            </Badge>

            <Text fontWeight="600">[Ticket#8205479] Interested in buying</Text>
          </HStack>

          <Button colorScheme="red" size="sm">
            ✕ Close Ticket
          </Button>
        </Flex>

        {/* Reply Box */}
        <Textarea placeholder="Enter reply here" minH="150px" mb={4} />

        {/* Actions */}
        <Flex justify="space-between" align="center" flexWrap="wrap" gap={4}>
          <Button
            leftIcon={<AttachmentIcon />}
            bg="gray.900"
            color="white"
            _hover={{ bg: "gray.800" }}
          >
            Add Attachment
          </Button>

          <Button
            colorScheme="purple"
            rightIcon={<Icon as={FiCornerDownLeft} />}
          >
            Reply
          </Button>
        </Flex>

        {/* Attachment Info */}
        <Text fontSize="sm" color="blue.500" mt={3}>
          Max 5 files can be uploaded | Maximum upload size is 256MB | Allowed
          File Extensions: .jpg, .jpeg, .png, .pdf, .doc, .docx
        </Text>

        <Divider my={6} />

        {/* Message Box */}
        <Box
          border="1px solid"
          borderColor="purple.300"
          borderRadius="md"
          p={{ base: 4, md: 6 }}
        >
          <Flex direction={{ base: "column", md: "row" }} gap={6}>
            {/* User Info */}
            <VStack minW={{ md: "200px" }} align="start" spacing={2}>
              <Text fontWeight="700">Mayank</Text>
              <Text color="gray.500">@Mayank</Text>

              <Button
                leftIcon={<Icon as={FiTrash2} />}
                size="sm"
                colorScheme="red"
              >
                Delete
              </Button>
            </VStack>

            {/* Message */}
            <Box flex="1">
              <Text fontSize="sm" color="gray.500" mb={2}>
                Posted on Monday, 15th December 2025 @ 09:46 pm
              </Text>

              <Text color="gray.700">
                Hi i want to buy this code with proper working and api contact
                me at above email or at +971-52 475 9970
              </Text>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default ReplyTicket;
